import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faq } from "../data/mock";
import { useT } from "../context/LanguageContext";

const FAQSection = ({ onTalkAgent }) => {
  const t = useT();
  const faqItems = [
    { q: t("faq.item1.q"), a: t("faq.item1.a") },
    { q: t("faq.item2.q"), a: t("faq.item2.a") },
    { q: t("faq.item3.q"), a: t("faq.item3.a") },
    { q: t("faq.item4.q"), a: t("faq.item4.a") },
    { q: t("faq.item5.q"), a: t("faq.item5.a") },
    { q: t("faq.item6.q"), a: t("faq.item6.a") },
    { q: t("faq.item7.q"), a: t("faq.item7.a") },
    { q: t("faq.item8.q"), a: t("faq.item8.a") },
  ];
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setVisible(true), obs.disconnect()),
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="faq"
      ref={ref}
      className={`section-fade ${visible ? "visible" : ""} py-20 px-6 flex items-center`}
      style={{ minHeight: "100vh", background: "var(--section-surface-1)" }}
    >
      <div className="max-w-4xl mx-auto w-full">
        <div className="flex flex-col items-center text-center mb-12">
          <span
            className="inline-block px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider mb-4"
            style={{
              background: "var(--bg)",
              border: "1px solid var(--border)",
              color: "var(--muted)",
            }}
          >
            {t("faq.eyebrow")}
          </span>
          <h2 className="font-bold tracking-tight" style={{ color: "var(--fg)", fontSize: "clamp(2rem, 4.2vw, 3.25rem)" }}>
            {t("faq.title1")} <span className="brand-gradient-text">{t("faq.title2")}</span>{t("faq.title3")}
          </h2>
          <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--fg)", opacity: 0.92 }}>
            {t("faq.subtitle")}
          </p>
        </div>

        {/* FAQ visual */}
        <div className="mb-10 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
          <img
            src="/images/pages/faq-hero-new.jpg"
            alt="Destek ve yardım"
            className="w-full h-auto object-cover"
            style={{ maxHeight: "280px" }}
            loading="lazy"
          />
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full rounded-2xl overflow-hidden neon-box"
          style={{ background: "var(--bg)", border: "1px solid var(--border)" }}
        >
          {faqItems.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="px-6 border-b last:border-b-0"
              style={{ borderColor: "var(--border)" }}
            >
              <AccordionTrigger
                className="text-left text-[15px] font-semibold py-5"
                style={{ color: "var(--fg)" }}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-[14px] leading-relaxed pb-5"
                style={{ color: "var(--fg)", opacity: 0.9 }}
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-10">
          <p className="text-[13.5px] mb-3" style={{ color: "var(--muted)" }}>
            {t("faq.noAnswer")}
          </p>
          <button
            onClick={onTalkAgent}
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[14px] font-semibold neon-btn"
          >
            {t("faq.askVera")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
